import React, { useEffect } from 'react';
import { useUIStore } from '../../stores/uiStore';

const Toast: React.FC = () => {
  const notification = useUIStore((s) => s.notification);
  const clearNotification = useUIStore((s) => s.clearNotification);

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(clearNotification, 3000);
      return () => clearTimeout(timer);
    }
  }, [notification, clearNotification]);

  if (!notification) return null;

  const bgColor = {
    success: 'bg-emerald-600',
    error: 'bg-red-600',
    info: 'bg-blue-600',
    warning: 'bg-amber-600',
  }[notification.type];

  return (
    <div className={`fixed top-4 right-4 z-[10000] px-4 py-2.5 ${bgColor} text-white text-sm rounded-lg shadow-lg flex items-center gap-2 animate-fade-in`}>
      <span>{notification.message}</span>
      <button onClick={clearNotification} className="ml-2 text-white/70 hover:text-white">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default Toast;
